// extracted by mini-css-extract-plugin
export default {"wrapper":"large-icon-text_wrapper__ZtP7-","icon":"large-icon-text_icon__FW+fN","text":"large-icon-text_text__yPZKN","subtext":"large-icon-text_subtext__xkwVd"};